import { useState, useEffect, memo } from 'react';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Switch, FormControlLabel, Tooltip, IconButton } from '@mui/material';
import ResultsStore from '../../../stores/ResultsStore';
import { useElalCompany } from '../../../hooks/useElalCompany';
import { useLocation, useNavigate } from 'react-router-dom';

const PointsToggleComponent = memo(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isElal = useElalCompany();
    const useMaxPointsParam = new URLSearchParams(location.search).get('use_max_points') === 'true';

    const [showPricesInPoints, setShowPricesInPoints] = useState(useMaxPointsParam);

    useEffect(() => {
        ResultsStore.setShowPricesInPoints(useMaxPointsParam);
    }, []);
 
    const handleToggle = (event) => {
        const checked = event.target.checked;
        ResultsStore.setShowPricesInPoints(checked);
        setShowPricesInPoints(checked);

        const params = new URLSearchParams(location.search);
        params.set('use_max_points', String(checked));
        navigate({ search: params.toString() }, { replace: true });
    };

    if (!isElal) {
        return null;
    }

    return (
        <div className="points-toggle-component">
            <FormControlLabel
                control={
                    <Switch
                        checked={showPricesInPoints}
                        onChange={handleToggle}
                        color="primary"
                        data-testid="points-toggle-switch"
                    />
                }
                label={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span>{t('ShowMaxPointsPrice')}</span>
                    </div>
                }
                labelPlacement="start"
            />
        </div>
    );
});

export default PointsToggleComponent;
